/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    CabinClassTTLOCriteriaOutput,
    CabinClassTTLOCriteriaOutputFromJSON,
    CabinClassTTLOCriteriaOutputFromJSONTyped,
    CabinClassTTLOCriteriaOutputToJSON,
    CharTTLOCriteriaOutput,
    CharTTLOCriteriaOutputFromJSON,
    CharTTLOCriteriaOutputFromJSONTyped,
    CharTTLOCriteriaOutputToJSON,
    CodeAndLabel,
    CodeAndLabelFromJSON,
    CodeAndLabelFromJSONTyped,
    CodeAndLabelToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
    JourneyTTLOCriteriaOutput,
    JourneyTTLOCriteriaOutputFromJSON,
    JourneyTTLOCriteriaOutputFromJSONTyped,
    JourneyTTLOCriteriaOutputToJSON,
    StringTTLOCriteriaOutput,
    StringTTLOCriteriaOutputFromJSON,
    StringTTLOCriteriaOutputFromJSONTyped,
    StringTTLOCriteriaOutputToJSON,
    TTLOCriteriaForRouteResponse,
    TTLOCriteriaForRouteResponseFromJSON,
    TTLOCriteriaForRouteResponseFromJSONTyped,
    TTLOCriteriaForRouteResponseToJSON,
    TTLODateTimeRestriction,
    TTLODateTimeRestrictionFromJSON,
    TTLODateTimeRestrictionFromJSONTyped,
    TTLODateTimeRestrictionToJSON,
    TTLOTravelDateRange,
    TTLOTravelDateRangeFromJSON,
    TTLOTravelDateRangeFromJSONTyped,
    TTLOTravelDateRangeToJSON,
    TicketTimeLimitOverrideTimeConfigItem,
    TicketTimeLimitOverrideTimeConfigItemFromJSON,
    TicketTimeLimitOverrideTimeConfigItemFromJSONTyped,
    TicketTimeLimitOverrideTimeConfigItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface TicketTimeLimitOverrideFormData
 */
export interface TicketTimeLimitOverrideFormData {
    /**
     * 
     * @type {string}
     * @memberof TicketTimeLimitOverrideFormData
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TicketTimeLimitOverrideFormData
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TicketTimeLimitOverrideFormData
     */
    disabled?: boolean;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof TicketTimeLimitOverrideFormData
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {Array<GuidIdCodeAndLabel>}
     * @memberof TicketTimeLimitOverrideFormData
     */
    carriers?: Array<GuidIdCodeAndLabel> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TicketTimeLimitOverrideFormData
     */
    suppliers?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TicketTimeLimitOverrideFormData
     */
    fareTypes?: Array<string> | null;
    /**
     * 
     * @type {TicketTimeLimitOverrideTimeConfigItem}
     * @memberof TicketTimeLimitOverrideFormData
     */
    time?: TicketTimeLimitOverrideTimeConfigItem;
    /**
     * 
     * @type {number}
     * @memberof TicketTimeLimitOverrideFormData
     */
    dayOffset?: number;
    /**
     * 
     * @type {object}
     * @memberof TicketTimeLimitOverrideFormData
     */
    effectiveDateFrom?: object | null;
    /**
     * 
     * @type {object}
     * @memberof TicketTimeLimitOverrideFormData
     */
    effectiveDateTo?: object | null;
    /**
     * 
     * @type {Array<Int32IdAndLabel>}
     * @memberof TicketTimeLimitOverrideFormData
     */
    channels?: Array<Int32IdAndLabel> | null;
    /**
     * 
     * @type {Array<StringTTLOCriteriaOutput>}
     * @memberof TicketTimeLimitOverrideFormData
     */
    accountCodes?: Array<StringTTLOCriteriaOutput> | null;
    /**
     * 
     * @type {number}
     * @memberof TicketTimeLimitOverrideFormData
     */
    relevance?: number;
    /**
     * 
     * @type {Array<CabinClassTTLOCriteriaOutput>}
     * @memberof TicketTimeLimitOverrideFormData
     */
    cabinClasses?: Array<CabinClassTTLOCriteriaOutput> | null;
    /**
     * 
     * @type {Array<CharTTLOCriteriaOutput>}
     * @memberof TicketTimeLimitOverrideFormData
     */
    bookingClasses?: Array<CharTTLOCriteriaOutput> | null;
    /**
     * 
     * @type {Array<JourneyTTLOCriteriaOutput>}
     * @memberof TicketTimeLimitOverrideFormData
     */
    journeyTypes?: Array<JourneyTTLOCriteriaOutput> | null;
    /**
     * 
     * @type {Array<TTLOCriteriaForRouteResponse>}
     * @memberof TicketTimeLimitOverrideFormData
     */
    routes?: Array<TTLOCriteriaForRouteResponse> | null;
    /**
     * 
     * @type {Array<GuidIdCodeAndLabel>}
     * @memberof TicketTimeLimitOverrideFormData
     */
    agencies?: Array<GuidIdCodeAndLabel> | null;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof TicketTimeLimitOverrideFormData
     */
    agencyGroups?: Array<GuidIdAndLabel> | null;
    /**
     * 
     * @type {Array<TTLODateTimeRestriction>}
     * @memberof TicketTimeLimitOverrideFormData
     */
    dateTimeRestrictions?: Array<TTLODateTimeRestriction> | null;
    /**
     * 
     * @type {CodeAndLabel}
     * @memberof TicketTimeLimitOverrideFormData
     */
    dateTimeRestrictionsTimeZone?: CodeAndLabel;
    /**
     * 
     * @type {Array<TTLOTravelDateRange>}
     * @memberof TicketTimeLimitOverrideFormData
     */
    travelDates?: Array<TTLOTravelDateRange> | null;
}

export function TicketTimeLimitOverrideFormDataFromJSON(json: any): TicketTimeLimitOverrideFormData {
    return TicketTimeLimitOverrideFormDataFromJSONTyped(json, false);
}

export function TicketTimeLimitOverrideFormDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): TicketTimeLimitOverrideFormData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'carriers': !exists(json, 'carriers') ? undefined : (json['carriers'] === null ? null : (json['carriers'] as Array<any>).map(GuidIdCodeAndLabelFromJSON)),
        'suppliers': !exists(json, 'suppliers') ? undefined : json['suppliers'],
        'fareTypes': !exists(json, 'fareTypes') ? undefined : json['fareTypes'],
        'time': !exists(json, 'time') ? undefined : TicketTimeLimitOverrideTimeConfigItemFromJSON(json['time']),
        'dayOffset': !exists(json, 'dayOffset') ? undefined : json['dayOffset'],
        'effectiveDateFrom': !exists(json, 'effectiveDateFrom') ? undefined : json['effectiveDateFrom'],
        'effectiveDateTo': !exists(json, 'effectiveDateTo') ? undefined : json['effectiveDateTo'],
        'channels': !exists(json, 'channels') ? undefined : (json['channels'] === null ? null : (json['channels'] as Array<any>).map(Int32IdAndLabelFromJSON)),
        'accountCodes': !exists(json, 'accountCodes') ? undefined : (json['accountCodes'] === null ? null : (json['accountCodes'] as Array<any>).map(StringTTLOCriteriaOutputFromJSON)),
        'relevance': !exists(json, 'relevance') ? undefined : json['relevance'],
        'cabinClasses': !exists(json, 'cabinClasses') ? undefined : (json['cabinClasses'] === null ? null : (json['cabinClasses'] as Array<any>).map(CabinClassTTLOCriteriaOutputFromJSON)),
        'bookingClasses': !exists(json, 'bookingClasses') ? undefined : (json['bookingClasses'] === null ? null : (json['bookingClasses'] as Array<any>).map(CharTTLOCriteriaOutputFromJSON)),
        'journeyTypes': !exists(json, 'journeyTypes') ? undefined : (json['journeyTypes'] === null ? null : (json['journeyTypes'] as Array<any>).map(JourneyTTLOCriteriaOutputFromJSON)),
        'routes': !exists(json, 'routes') ? undefined : (json['routes'] === null ? null : (json['routes'] as Array<any>).map(TTLOCriteriaForRouteResponseFromJSON)),
        'agencies': !exists(json, 'agencies') ? undefined : (json['agencies'] === null ? null : (json['agencies'] as Array<any>).map(GuidIdCodeAndLabelFromJSON)),
        'agencyGroups': !exists(json, 'agencyGroups') ? undefined : (json['agencyGroups'] === null ? null : (json['agencyGroups'] as Array<any>).map(GuidIdAndLabelFromJSON)),
        'dateTimeRestrictions': !exists(json, 'dateTimeRestrictions') ? undefined : (json['dateTimeRestrictions'] === null ? null : (json['dateTimeRestrictions'] as Array<any>).map(TTLODateTimeRestrictionFromJSON)),
        'dateTimeRestrictionsTimeZone': !exists(json, 'dateTimeRestrictionsTimeZone') ? undefined : CodeAndLabelFromJSON(json['dateTimeRestrictionsTimeZone']),
        'travelDates': !exists(json, 'travelDates') ? undefined : (json['travelDates'] === null ? null : (json['travelDates'] as Array<any>).map(TTLOTravelDateRangeFromJSON)),
    };
}

export function TicketTimeLimitOverrideFormDataToJSON(value?: TicketTimeLimitOverrideFormData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'allowEdit': value.allowEdit,
        'disabled': value.disabled,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'carriers': value.carriers === undefined ? undefined : (value.carriers === null ? null : (value.carriers as Array<any>).map(GuidIdCodeAndLabelToJSON)),
        'suppliers': value.suppliers,
        'fareTypes': value.fareTypes,
        'time': TicketTimeLimitOverrideTimeConfigItemToJSON(value.time),
        'dayOffset': value.dayOffset,
        'effectiveDateFrom': value.effectiveDateFrom,
        'effectiveDateTo': value.effectiveDateTo,
        'channels': value.channels === undefined ? undefined : (value.channels === null ? null : (value.channels as Array<any>).map(Int32IdAndLabelToJSON)),
        'accountCodes': value.accountCodes === undefined ? undefined : (value.accountCodes === null ? null : (value.accountCodes as Array<any>).map(StringTTLOCriteriaOutputToJSON)),
        'relevance': value.relevance,
        'cabinClasses': value.cabinClasses === undefined ? undefined : (value.cabinClasses === null ? null : (value.cabinClasses as Array<any>).map(CabinClassTTLOCriteriaOutputToJSON)),
        'bookingClasses': value.bookingClasses === undefined ? undefined : (value.bookingClasses === null ? null : (value.bookingClasses as Array<any>).map(CharTTLOCriteriaOutputToJSON)),
        'journeyTypes': value.journeyTypes === undefined ? undefined : (value.journeyTypes === null ? null : (value.journeyTypes as Array<any>).map(JourneyTTLOCriteriaOutputToJSON)),
        'routes': value.routes === undefined ? undefined : (value.routes === null ? null : (value.routes as Array<any>).map(TTLOCriteriaForRouteResponseToJSON)),
        'agencies': value.agencies === undefined ? undefined : (value.agencies === null ? null : (value.agencies as Array<any>).map(GuidIdCodeAndLabelToJSON)),
        'agencyGroups': value.agencyGroups === undefined ? undefined : (value.agencyGroups === null ? null : (value.agencyGroups as Array<any>).map(GuidIdAndLabelToJSON)),
        'dateTimeRestrictions': value.dateTimeRestrictions === undefined ? undefined : (value.dateTimeRestrictions === null ? null : (value.dateTimeRestrictions as Array<any>).map(TTLODateTimeRestrictionToJSON)),
        'dateTimeRestrictionsTimeZone': CodeAndLabelToJSON(value.dateTimeRestrictionsTimeZone),
        'travelDates': value.travelDates === undefined ? undefined : (value.travelDates === null ? null : (value.travelDates as Array<any>).map(TTLOTravelDateRangeToJSON)),
    };
}


